import { DialogTitle, Typography, Button, styled, Box } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const DialogTitleCustom = styled(DialogTitle)(() => ({
  padding: pxToRem(16),
  position: "relative",
  textAlign: "center",

  button: {
    position: "absolute",
    top: pxToRem(8),
    right: pxToRem(8),
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.md_16,
  fontWeight: theme.typography.fw_semibold_600,
  color: theme.palette.text.textPrimary,
}));

export const ButtonCustom = styled(Button)(({ theme }) => ({
  width: "100%",
}));

export const Description = styled(Box)(({ theme }) => ({
  padding: pxToRem(12),
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: pxToRem(12),
  backgroundColor: theme.palette.background.bgBrandPrimary,
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_regular_400,
  color: theme.palette.text.textPrimary,
  borderRadius: pxToRem(8),
}));

export const Note = styled(Box)(({ theme }) => ({
  padding: pxToRem(12),
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: pxToRem(12),
  backgroundColor: theme.palette.background.bgWarningPrimary,
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_regular_400,
  color: theme.palette.text.textPrimary,
  borderRadius: pxToRem(8),
}));

export const StepWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: pxToRem(12),
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_regular_400,
  color: theme.palette.text.textPrimary,
  borderRadius: pxToRem(8),
}));

export const TextBlue = styled("span")(({ theme }) => ({
  color: theme.palette.text.textLink,
}));

export const StepNumber = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50%",
  border: `1px solid ${theme.palette.stroke.strokeDefault}`,
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_semibold_600,
  color: theme.palette.text.textLink,
  height: pxToRem(24),
  width: pxToRem(24),
}));

export const StepLabel = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_semibold_600,
  color: theme.palette.text.textPrimary,
}));

export const QRWrapper = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
}));

export const QRImage = styled("img")(({ theme }) => ({
  height: pxToRem(220),
  width: pxToRem(220),
}));

export const QRNote = styled(Typography)(({ theme }) => ({
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.xs_12,
  fontWeight: theme.typography.fw_regular_400,
  color: theme.palette.text.textLink,
}));

export const TwoFECode = styled(Box)(({ theme }) => ({
  padding: `${pxToRem(16)} ${pxToRem(16)} ${pxToRem(24)} ${pxToRem(16)}`,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: pxToRem(12),
  borderRadius: pxToRem(12),
  backgroundColor: theme.palette.background.bgBase,
}));

export const TwoFECodeLabel = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.size.xs_12,
  lineHeight: theme.typography.lineHeight.md,
  color: theme.palette.text.textPrimary,
  fontWeight: theme.typography.fw_regular_400,
}));

export const CodeInputWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: pxToRem(10),
  justifyContent: "center",
  alignItems: "center",
}));

export const CodeInput = styled("input")(({ theme }) => ({
  width: pxToRem(48),
  height: pxToRem(48),
  textAlign: "center",
  color: theme.palette.text.textLink,
  fontSize: theme.typography.size.xl_20,
  lineHeight: theme.typography.lineHeight.md,
  fontWeight: theme.typography.fw_semibold_600,
  border: `1px solid ${theme.palette.stroke.strokeDefault}`,
  backgroundColor: theme.palette.background.bgPrimary,
  borderRadius: pxToRem(8),
  outline: "none",
  caretColor: "transparent",
  cursor: "pointer",
  transition: "all 0.3s ease",

  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
  "&[type=number]": {
    MozAppearance: "textfield",
  },

  "&:focus": {
    border: `1px solid ${theme.palette.stroke.strokeBrand}`,
    transform: "scale(1.05)",
  },
}));

export const ResetButton = styled(Button)(({ theme }) => ({
  background: theme.palette.colorsBase.blue_10,
  color: theme.palette.colorsBase.blue_0,
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_semibold_600,
  padding: `${pxToRem(8)} ${pxToRem(16)}`,
  width: pxToRem(150),
  height: pxToRem(36),

  ":hover": {
    background: theme.palette.colorsBase.blue_10,
  },
}));

export const CenteredBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  width: "100%",
}));

export const ResetQRImage = styled("img")(({ theme }) => ({
  height: pxToRem(165),
  width: pxToRem(165),
}));
